<nz-spin [nzSpinning]="loading$ | async">
  <form
    [formGroup]="attachmentForm"
    (ngSubmit)="onSubmit($event)"
    nz-form
    class="form">
    <div class="drawer-form-wrapper">
      <nz-form-item>
        <nz-form-label [nzRequired]="!isViewMode" nzFor="folderId"
          >Folder</nz-form-label
        >
        <nz-form-control>
          <nz-select
            nzShowArrow="true"
            nzSuffixIcon
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Folder"
            formControlName="folderId"
            name="folderId"
            [nzShowArrow]="true">
            @for (folder of folders; track folder) {
              <nz-option
                [nzLabel]="folder.name"
                [nzValue]="folder.id"></nz-option>
            }
          </nz-select>
          <div
            class="ant-form-item-explain-error mt-3"
            *ngIf="!attachmentForm.value.folderId">
            Please select Folder.
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzRequired]="!isViewMode" nzFor="name"
          >Name</nz-form-label
        >
        <nz-form-control [nzErrorTip]="nameErrorTpl">
          <input
            nz-input
            id="name"
            formControlName="name"
            placeholder="Enter name" />
          <ng-template #nameErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Please input name</ng-container
            >
            <ng-container *ngIf="control.hasError('minlength')">
              Name must be at least {{ MIN_NAME_LENGTH }} characters
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Name must be less than {{ MAX_NAME_LENGTH }} characters
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzRequired]="!isViewMode" nzFor="description"
          >Description</nz-form-label
        >
        <nz-form-control [nzErrorTip]="descriptionErrorTpl">
          <textarea
            nz-input
            id="description"
            formControlName="description"
            rows="4"
            placeholder="Enter description"></textarea>
          <div class="mt-3 remaining-text">
            {{
              attachmentForm.value.description
                ? attachmentForm.value.description.length
                : 0
            }}
            of 500 characters used
          </div>
          <ng-template #descriptionErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')"
              >Please input description</ng-container
            >
            <ng-container *ngIf="control.hasError('minlength')">
              Description must be at least
              {{ MIN_DESCRIPTION_LENGTH }} characters
            </ng-container>
            <ng-container *ngIf="control.hasError('maxlength')">
              Description must be at most
              {{ MAX_DESCRIPTION_LENGTH }} characters
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control [nzErrorTip]="attachmentErrorTpl">
          <nz-upload
            [nzFileList]="fileList"
            [nzBeforeUpload]="beforeUpload"
            [nzRemove]="handleRemove"
            [nzIconRender]="iconTemplate"
            nzListType="picture"
            [nzShowUploadList]="{
              showRemoveIcon: !isViewMode,
              showPreviewIcon: true,
              showDownloadIcon: false,
            }"
            [nzDisabled]="isViewMode"
            nzDrop
            [nzMultiple]="false"
            class="file-upload">
            <button nz-button type="button" [disabled]="isViewMode">
              <div class="upload-icon">
                <svg-icon
                  [title]="'Upload file'"
                  src="/assets/icon/icon-upload.svg"
                  class="icon s-12"
                  aria-label="Upload"></svg-icon>
              </div>
              <div class="wrapper">
                <p class="text s-14 fw-600 green">
                  Click to upload
                  <span class="text s-14 fw-400">or drag and drop</span>
                </p>
                <p class="text s-12 fw-400">
                  Supported formats: PDF, Office, Media & Images
                </p>
              </div>
            </button>
          </nz-upload>

          <ng-template #attachmentErrorTpl let-control>
            <ng-container *ngIf="control.hasError('required')">
              Please upload a file
            </ng-container>
            <ng-container *ngIf="control.hasError('maxSize')">
              File size cannot exceed 5MB
            </ng-container>
            <ng-container *ngIf="control.hasError('invalidType')">
              Invalid file type. Supported formats: PDF, DOC, DOCX, XLS, XLSX,
              PPT, PPTX, MP3, WAV, M4A, MP4, M4V, TIF, TIFF
            </ng-container>
          </ng-template>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div class="display-flex justify-content-between drawer-footer">
      <button
        *ngIf="isCreateMode || isEditMode || isViewMode"
        type="button"
        nz-button
        nzType="default"
        type="button"
        (click)="cancleDrawer()">
        Cancel
      </button>

      <ng-container [ngSwitch]="true">
        <button
          *ngSwitchCase="isViewMode"
          type="button"
          nz-button
          nzType="primary"
          type="button"
          (click)="onEdit()">
          Edit
        </button>

        <button
          *ngSwitchCase="isEditMode || isCreateMode"
          type="button"
          nz-button
          nzType="primary"
          type="submit"
          [disabled]="attachmentForm.invalid">
          {{ isCreateMode ? 'Submit' : 'Save' }}
        </button>
      </ng-container>
    </div>
  </form>
</nz-spin>

<ng-template #iconTemplate let-file>
  <svg-icon
    src="/assets/icon/icon-report-green.svg"
    class="icon s-12"
    aria-label="Report Green"></svg-icon>
</ng-template>
